import styled, { css } from "styled-components";
import { IStyledLastRowProps, IComposerImgProps } from "./interfaces";

export const StyledLastRow = styled.div<IStyledLastRowProps>`
    display: flex;
    justify-content: space-between;
    ${p =>
        p.tiny
            ? css`
                  display: none;
              `
            : undefined}
`;

export const LastModified = styled.div`
    color: ${p => p.theme.c.greyA};
    font-weight: 300;
    flex: 1;
    line-height: 1.3;
    height: 52px;
    padding: 0 12px;
    display: flex;
    align-items: center;

    .i-alert {
        position: relative;
        top: 1px;
        font-size: 22px;
        color: ${p => p.theme.c.incorrect};
        vertical-align: text-bottom;
        display: inline-block;
        margin: -2px 4px 0px 0;
    }
    .i-clock {
        color: ${p => p.theme.c.info};
    }
`;

export const BasicInfo = styled(LastModified)`
    display: flex;
    align-items: center;
    padding: 0 10px;
`;

export const ComposerImg = styled.div<IComposerImgProps>`
    width: 26px;
    height: 26px;
    background-image: url(${p => p.src});
    background-size: cover;
    border-radius: 13px;
    display: inline-block;
    margin-right: 8px;
    flex-shrink: 0;
`;

export const Public = styled.div`
    text-align: right;
    margin-right: 4px;
`;

export const StartPlay = styled.button`
    display: block;
    flex: 1;
    max-width: 100% !important;
    border: none;
    outline: none;
    cursor: pointer;
    height: 46px;
    color: ${p => p.theme.mode === "dark" ? p.theme.c.snowOnActive : p.theme.c.dark};
    background-color: transparent;
    font-variant: small-caps;
    font-size: 24px;
`;

export const ArchiveWrapper = styled.div`
    padding-top: 16px;
    padding-right: 12px;
`;

export const ComposerRow = styled.div`
    display: flex;
    align-items: center;
    &.Clickable {
        cursor: pointer;
    }
`;
